// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Container } from '../../../lib/base';

interface Props {
  children: React.ReactNode;
}
export const AppBarShell = ({ children }: Props) => (
  <Container
    component="header"
    sx={{ paddingLeft: 3, paddingRight: 3, paddingTop: 2, paddingBottom: 2 }}
    id="app-bar-shell"
  >
    {children}
  </Container>
);
